import React, { ReactNode, useEffect, useState } from 'react';

interface TooltipProps {
  content: string;
  children: ReactNode;
  className?: string;
  position?: 'top' | 'bottom' | 'left' | 'right' | 'far-left' | 'far-right';
}

const Tooltip: React.FC<TooltipProps> = ({
  content,
  children,
  className = '',
  position = 'top',
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [hasCursor, setHasCursor] = useState(true);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(
        /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      );
    };

    const checkCursor = () => {
      setHasCursor(window.matchMedia('(hover: hover)').matches);
    };

    checkIsMobile();
    checkCursor();
    window.addEventListener('resize', checkIsMobile);
    window.addEventListener('mousemove', checkCursor);

    return () => {
      window.removeEventListener('resize', checkIsMobile);
      window.removeEventListener('mousemove', checkCursor);
    };
  }, []);

  if (isMobile || !hasCursor) {
    return <>{children}</>;
  }

  return (
    <div className={`tooltip-wrapper ${className}`}>
      {children}
      <div className={`tooltip-content tooltip-${position}`}>{content}</div>
    </div>
  );
};

export default Tooltip;
